import i18n from "./i18n";

const LOCALES = [
  {
    value: "en",
    label: "🇬🇧 English",
  },
  { value: "ar", label: "🇸🇦 العربية" },
] as const;

const LANGUAGE = i18n.language as (typeof LOCALES)[number]["value"];

const MANTINE_COLORS_MAP = [
  "red",
  "pink",
  "grape",
  "violet",
  "indigo",
  "blue",
  "cyan",
  "teal",
  "green",
  "lime",
  "yellow",
  "orange",
] as const;

// TODO:
const DEMO = import.meta.env.VITE_PUBLIC_DEMO === "true";
// const DEMO = true;

export const CONSTANTS = {
  LOCALES,
  LANGUAGE,
  MANTINE_COLORS_MAP,
  DEMO,
};
